import {
	Modal,
	MimaButton,
	MimaInput,
	MimaDropdown,
	MimaText,
} from '../../components';
import styles from '../../assets/styles/Inventory/Inventory.module.scss';
import { Formik } from 'formik';
import { inventoryStore } from '../../stores';
import React from 'react';

const UpdateRateCard = ({ closeModal, loading, validationSchema, onSubmit }) => {
	const { selectedRateCard } = inventoryStore;

	return (
		<Modal closeModal={closeModal} goBack={closeModal}>
			<MimaText variant="subtitleBold" align="center" mb={2} color="var(--color-primary)">
				Update  {selectedRateCard?.grade} {selectedRateCard?.title} Rate Card
			</MimaText>
			<Formik
				initialValues={{
					title: selectedRateCard.title || '',
					grade: selectedRateCard.grade,
					sellingPrice: selectedRateCard.sellingPrice,
					splitPercentage: selectedRateCard.splitPercentage || 0,
					status: selectedRateCard.status
				}}
				validationSchema={validationSchema}
				onSubmit={onSubmit}>
				{({
					handleChange,
					handleBlur,
					handleSubmit,
					values,
					errors,
					touched,
					setFieldValue,
				}) => (
					<div>
						<MimaInput
							type="text"
							labelTitle="Title"
							name="title"
							id="title"
							value={values.title}
							onChange={handleChange}
							error={errors.title}
							touched={touched.title}
							onBlur={handleBlur}
						/>
						<MimaInput
							type="number"
							labelTitle="Selling Price"
							name="sellingPrice"
							id="sellingPrice"
							value={values.sellingPrice}
							onChange={handleChange}
							error={errors.sellingPrice}
							touched={touched.sellingPrice}
							onBlur={handleBlur}
						/>

						<MimaInput
							type="number"
							labelTitle="Split Percentage"
							name="splitPercentage"
							id="splitPercentage"
							value={values.splitPercentage}
							onChange={handleChange}
							error={errors.splitPercentage}
							touched={touched.splitPercentage}
							onBlur={handleBlur}
						/>
						<MimaDropdown
							labelTitle="Status"
							placeholder="Select Status"
							name="status"
							currentValue={values.status}
							id="status"
							onChange={data => {
								setFieldValue('status', data.value);
							}}
							data={[
								{
									key: 'ACTIVE',
									value: 'ACTIVE',

								},
								{
									key: 'DELETE',
									value: 'INACTIVE',

								}
							]}
						/>
						{errors.status ? (
							<div className={styles.error}>
								{''}
								{touched.status && errors.status}
								{''}
							</div>
						) : null}


						<MimaButton
							title="Save Edit"
							onClick={handleSubmit}
							variant="form"
							loading={loading}
						/>
					</div>
				)}
			</Formik>
		</Modal>
	);
};

export default UpdateRateCard;
